import React, {createContext, useContext, useReducer, useCallback } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import Portal from '@material-ui/core/Portal';
import Alert from '@material-ui/lab/Alert';

const SnackInit={
	open:false,
	message:'',
	severity:''
};
export const SnackContext=createContext(SnackInit);

function DottieSnackbar(){
	const { SnackState, setSnack }=useContext(SnackContext);

	const onClose=()=>{
		setSnack({type:'close'});
	};

	return (
		<Portal>
			<Snackbar open={ SnackState.open } autoHideDuration={6000} onClose={onClose}>
				<Alert onClose={onClose} severity={SnackState.severity || 'error'}>{ SnackState.message }</Alert>
			</Snackbar>
		</Portal>
	);
}

export const useSnacks=()=>{
	const { setSnack }=useContext(SnackContext);

  const showError=useCallback((message)=>{
	  setSnack({
		  type:'snack',
		  message:message,
		  severity:'error'
	  });
  },[setSnack]);

  const showWarning=useCallback((message)=>{
		setSnack({
			type:'snack',
			message:message,
			severity:'error'
		});
	},[setSnack]);

	const showInfo=useCallback((message)=>{
		setSnack({
			type:'snack',
			message:message,
			severity:'error'
		});
	},[setSnack]);

	const showSuccess=useCallback((message)=>{
		setSnack({
			type:'snack',
			message:message,
			severity:'success'
		});
	},[setSnack]);

	return {
		showError:showError,
		showWarning:showWarning,
		showInfo:showInfo,
		showSuccess:showSuccess
	}
}

export const SnackContextProvider=({ children })=>{
	const [state, dispatch] = useReducer((state, action) => {
		switch(action.type) {
			case 'snack':
				return { ...state, message: action.message, severity: action.severity, open:true };
			case 'close':
				return SnackInit;
			default:
				throw new Error();
		};
	},SnackInit);

	return <SnackContext.Provider value={{ SnackState:state, setSnack:dispatch }}>{children}<DottieSnackbar /></SnackContext.Provider>;
}

export default SnackContextProvider
